<template>
  <div class="container-fluid" style="background-color: #F3F3F3">
    <div class="container is-fluid banner-section bg-img">
      <p class="pb-banner-title">
        INSIGHTS
      </p>
      <span class="yellow-line"></span>
    </div>
    <div class="content-wrapper">
      <div v-for="(item, index) in insights" :key="index" class="item-wrapper">
        <div class="text-box">
          <div class="pb-header">{{ item.attributes.title ? item.attributes.title : ''}}</div>
          <div class=" my-5 item-desc">{{ item.attributes.description ? item.attributes.description : ''}}</div>
          <router-link :to="{ name: item.attributes.link ? item.attributes.link : '' }">
            <b-button :disabled="item.attributes.link == null" type=" submit" class="button dark-red"
              icon-right="play">Learn More</b-button>
          </router-link>
        </div>
        <div class="item-img">
          <img :src="item.attributes.image.data ? item.attributes.image.data.attributes.url : require('@/assets/img/default_photo_big.jpg')" />
        </div>
      </div>
      <div class="is-flex is-justify-content-end">
        <ScrollTop />
      </div>
    </div>
  </div>
</template>

<script>
import ScrollTop from '../../components/ScrollTop.vue';

export default {
  components: {
    ScrollTop
  },
  data() {
    return {
      hideButton: true,
      dataLength: 0,
      insights: [],
      contentList: [],
      insightsTitleList: [],
      counter: 0
    };
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.$httpClientCMS({
      method: 'GET',
      url: 'api/insights?populate=*'
    })
      .then(resp => {
        let insights = resp.data.data;
        this.$set(this, 'insights', insights);
        this.dataLength = insights.length;
        this.$set(this, "contentList", insights);
        this.resourceTitleList = insights.map(i => i.attributes.title);

      })
      .catch((error) => {
        this.$router.push('maintenance');
      });
    loadingComponent.close()
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/font.scss';

.banner-section {
  background: url('../../assets/img/banner/insight-banner.jpg') center;
}

@media screen and (max-width:1290px) and (min-width: 1024px) {}


@media (max-width:1023px) {

  .banner-section {
    background-position: right 30% center !important;
  }


}

@media (max-width: 768px) {}

@media (max-width: 565px) {}
</style>